<template>
    <div style="width: 100%;">
        <div class="d-flex col-12">
            <div class="form-control-label" style="white-space: pre-line;">{{ title }}</div>
        </div>

        <videos :videos="content.data.videos" />
    </div>
</template>

<script>
import Constants from '../../constants';
import Videos from '../landing/Videos.vue';

export default {
	components: { Videos },
    props: ['question', 'providerId', 'context', 'answer'],
    data() {
        const content = this.question.content;
        return {
            id: this.question.id,
            content,
            status: this.question.status,
            adminQuestion: this.question.question,
            Constants,
            showInvalid: false,
        };
    },
    computed: {
        title: function() {
            return this.content.meta.title || '';
        },
        hasAnswer() {
            return false;
        },
        hasValidAnswer() {
            return true;
        },
    },
    methods: {
        highlightInvalidState() {
            this.showInvalid = true;
        },
        getDataToPersist() {
            return {
                question_id: this.id,
                answer: '',
                answer_id: null
            };
        },
    }
}
</script>

<style scoped></style>
